import React from 'react'

export function TdActions (props) {
  const wrapClass = () => {
    let activeBtns = 0
    for (let i = 0; i < props.children.length; i++) {
      if (props.children[i]) {
        // Nested button group (additional buttons)
        if (Array.isArray(props.children[i])) {
          const group = props.children[i]
          for (let j = 0; j < group.length; j++) {
            if (group[j]) activeBtns++
          }
        } else {
          activeBtns += 1
        }
      }
    }
    return activeBtns
  }

  return (<td className='td-actions'>
    <div className={wrapClass() > 1 ? 'btn-actions' : 'btn-action'}>
      <div className='btn-actions__innter'>{props.children}</div>
    </div>
  </td>)
}



// WEBPACK FOOTER //
// ./src/components/tdActions.js